module.exports = __webpack_public_path__ + "img/Travelers-home.7a653a9d.png";